import { useQuery } from '@tanstack/react-query';

import { getSummaryData } from '../api/ventura/contract';
import { useConfig } from './useConfig';

// The contract summary tiles opt into the per-domain flip via
// apiHostFor('contractReportsBigQuery') — ACH serves this route as of ACH-3f3z, replacing
// Rails' CALL of the BigQuery proc Logan.get_summary_data with the same query
// unrolled. No response adaptation: the {"data":[row]} envelope is identical and
// the consumer reads the row positionally either way.
//
// ONE DELIBERATE DIFFERENCE, ratified: y7 (Internal Spend). Rails serializes that
// NUMERIC through BigDecimal#as_json, which is engineering notation ("0.12345E3"),
// and currency.js strips the exponent — so on the Rails leg this tile USED TO render
// 0.12 for $123.45. ACH emits a plain decimal. The difference is now WIRE-ONLY: since
// ACH-ydg7, ContractSummaryData runs parseApiNumeric before currency.js, which
// normalizes the exponent form, so BOTH legs render the same figure. Do not expect a
// visible tile difference when diffing the two backends — only a wire one (ratified
// R-6 / ACH-ydg7).
function useContractSummaryData(contractId: number) {
  const { apiHostFor } = useConfig();
  const bigQueryHost = apiHostFor('contractReportsBigQuery');

  const query = useQuery({
    queryKey: ['contractSummaryData', contractId],
    queryFn: () => getSummaryData(bigQueryHost, contractId),
  });

  return query;
}

export default useContractSummaryData;
